import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import Message from 'rc-message';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { IconNames } from '@blueprintjs/icons';
import { DATE_FORMAT, getWindowConfig } from 'config';
import { Icon, Intent } from '@blueprintjs/core';
import Permissions from 'react-redux-permissions';

import Clearfix from 'components/elements/clearfix';
import Confirm from 'components/elements/confirm-element';
import { BaseListContainer } from 'containers/BaseContainer/BaseListContainer';
import { COLOR } from 'config';

const SpinnerContainer = styled.div`
  height: 40px;
  text-align: center;
  font-size: 10px;
`;

@connect((state) => ({
  token: state.auth.token,
}))
export default class AttachmentList extends BaseListContainer {
  static propTypes = {
    getListFunc: PropTypes.func.isRequired,
    deleteOne: PropTypes.func.isRequired,
    facility: PropTypes.object.isRequired,
  };

  constructor(props) {
    const funcApi = {
      getList: props.getListFunc,
    };

    let columns = [
      {
        dataField: '_id',
        text: '',
        headerStyle: {
          width: 10,
          minWidth: 10,
        },
        formatter: (cell, row) => {
          return (
            <div>
              <Permissions allowed={[`${this.props.moduleName}.delete`]}>
                <Icon
                  style={{ cursor: 'pointer' }}
                  icon={IconNames.DISABLE}
                  iconSize={Icon.SIZE_LARGE}
                  intent={Intent.DANGER}
                  onClick={() => {
                    this.handelDelete(cell);
                  }}
                />
              </Permissions>
            </div>
          );
        },
      },
      {
        dataField: 'attachment.Title',
        text: 'Tên báo cáo',
      },
      {
        dataField: 'attachment.attachmentType.Name',
        text: 'Loại',
      },
      {
        dataField: 'attachment',
        text: 'File',
        formatter: (cell, row) => {
          return (
            <a
              style={{
                display: 'inline-flex',
                color: COLOR.SECOND_COLOR,
                textDecoration: 'underline',
              }}
              href={
                getWindowConfig().storagePath +
                cell.FileNameServer +
                `?token=${this.props.token}`
              }
            >
              {cell.FileNameDisplay} <Clearfix width={8} />
              {`(${cell.NumBytes} KB)`}
            </a>
          );
        },
      },
      {
        dataField: 'attachment.Description',
        text: 'Chú thích',
      },
      {
        dataField: 'attachment.AddedOn',
        text: 'Thêm vào',
        formatter: (cell, row) => {
          return moment(cell).format(DATE_FORMAT);
        },
      },
      {
        dataField: 'attachment.AddedBy',
        text: 'Thêm bởi',
      },
    ];
    super(props, funcApi, columns);
    this.state = {
      ...this.state,
    };
    this.myRef = React.createRef();
  }

  componentDidMount() {
    this.props.onRef(this);
  }

  handelDelete = (_id) => {
    if (this.ConfirmElm && this.ConfirmElm.showConfirm) {
      this.ConfirmElm.showConfirm({
        content: 'Bạn có muốn xoá ',
        cb: async (value) => {
          if (value) {
            const res = await this.props.deleteOne(_id);
            if (res.success) {
              Message.success({ content: 'Thành Công' });
              this.fetData();
            }
            if (res.error) Message.error({ content: res.message });
          }
        },
      });
    }
  };

  renderHeaderContainer() {
    return (
      <div>
        <Confirm ref={(ConfirmElm) => (this.ConfirmElm = ConfirmElm)} />
      </div>
    );
  }

  renderSearchContainer() {
    return <div />;
  }

  renderSpinnerNodata() {
    return (
      <SpinnerContainer className='spinner'>
        <h2>No Attachment Data</h2>
      </SpinnerContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/FacilityHazarWasteReportContainer/FacilityHazarWasteReportView/Attachment/AttachmentList/index.js